import Axios from "axios";
import { useEffect, useState } from "react";
import { MONTH_ENUM, REQUEST_DATASOURCE, REQUEST_DOWLOAD_DESCRIPTION, REQUEST_SOURCE, REQUEST_STATUS, getDatasetNameByDataSource } from "../../../core/dictionary/global";
import { getFirstLetterCapital } from "../../../core/global/global-country-functions";
import { getApiUrl } from "../../../utils/baseUrl";
import RequestCenterFilter from "./Request-center-filter";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import ReactTableTrademo from "../../../shared/trademo-datatable/react-table-trademo";
import LoaderImg from "@assets/images/loader.gif";
import { captureException } from "@sentry/react";

let apiEndpoint = {
  getDownloadShipments: getApiUrl("getDownloadShipments"),
  notification_center: getApiUrl("notification_center/get_notifications"),
};

const sortingColumn = [
  {
    columnKey: "requestDate",
    value: "requestDate",
    isDefault: true,
  },
];

export const RequestDownloads = ({ propsDataList, downloadDownloadedFiles, alertStatus, alertDataSource, showDataSource, setShowDataSource, setShowStatus, showStatus, setAlertDataSource, setAlertStatus, loader, callingTrackingEvents, setShowDescription, setDescription, showDescription, description, setLoader, GLOBALPLAN }) => {
  const [column, setColumn] = useState([]);
  const [statusCount, setStatusCount] = useState(0);
  const [dataSourceCount, setDataSourceCount] = useState(0);
  const [descriptionCount, setDescriptionCount] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [currentpage, setCurrentpage] = useState(1);
  const [sortOrderValue, setSortOrderValue] = useState("desc");

  useEffect(() => {
    setColumnHandler();
  }, [showDataSource, showStatus, dataSourceCount, statusCount, showDescription, descriptionCount, dataList, sortOrderValue, dataList, propsDataList]);

  useEffect(() => {
    setDataList(propsDataList.map((item, index) => ({ ...item, s_no: index })));
  }, [propsDataList]);

  const setColumnHandler = () => {
    let Columns = [
      {
        name: "S. No",
        maxWidth: "50px",
        minWidth: "50px",
        selector: (row) => <div className="ml-2">{row.sNo}</div>,
      },
      {
        name: "Request ID",
        wrap: true,
        grow: 1,
        selector: (row) => <span>{row.requestId}</span>,
      },
      {
        name: "Request Date",
        wrap: true,
        selector: (row) => <div>{`${MONTH_ENUM[new Date(row.requestDate).getMonth()]} ${new Date(row.requestDate).getDate()}, ${new Date(row.requestDate).getFullYear()}`}</div>,
        grow: 1,
        key: "requestDate",
        sortable: true,
      },
      {
        name: (
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="position-relative cursor-pointer">
            <span
              onClick={(e) => {
                e.stopPropagation();
                setShowDataSource(!showDataSource);
                setShowDescription(false);
                setShowStatus(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreDownloadsDatasourceFilter);
              }}>
              Datasource <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {dataSourceCount ? (
              <span className="green-badge new-notification-center">
                <span>{dataSourceCount}</span>
                <span onClick={() => clearFilterHandler("datasource")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            <span>{showDataSource ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByDataSource} data={alertDataSource} /> : null}</span>
          </span>
        ),
        id: "dataSource",
        wrap: true,
        grow: 1,
        selector: (row) => (
          <span
          // className="text-capitalize"
          >
            {getDatasetNameByDataSource(row?.dataSource) ?? (row?.dataSource ? getFirstLetterCapital(row.dataSource) : "")}
          </span>
        ),
      },
      {
        name: (
          <span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setShowDescription(!showDescription);
                setShowDataSource(false);
                setShowStatus(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreDownloadsDescriptionFilter);
              }}>
              Request Description <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {descriptionCount ? (
              <span className="green-badge cursor-pointer new-notification-center">
                <span>{descriptionCount}</span>
                <span onClick={() => clearFilterHandler("description")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            {showDescription ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByDescriptionHandler} data={description} /> : null}
          </span>
        ),
        wrap: true,
        selector: (row) => (
          <div>
            <p className="m-0 text-capitalize">{row.requestType ? row.requestType : ""}</p>
            <p className="m-0">
              {row.size} records requested from {row.level === 2 || row.level === "2" ? "2nd level" : ""} {(row.level === 2 || row.level === "2") && (row.requestType === "importers" || row.requestType === "exporters") ? "Hierarchy " : row.requestType === "importers" || row.requestType === "exporters" ? "Unique " + row.requestType : row.requestType} {row.type ? row.type : ""}
            </p>
          </div>
        ),
        grow: 2,
      },
      {
        name: (
          <span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setShowStatus(!showStatus);
                setShowDescription(false);
                setShowDataSource(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreDownloadsStatusFilter);
              }}>
              Status <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {statusCount ? (
              <span className="green-badge cursor-pointer new-notification-center">
                <span>{statusCount}</span>
                <span onClick={() => clearFilterHandler("status")} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            {showStatus ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByStatusHandler} data={alertStatus} /> : null}
          </span>
        ),
        wrap: true,
        selector: (row) => <div>{statusHandling(row)}</div>,
        grow: 2,
      },
      {
        name: "Action",
        wrap: true,
        maxWidth: "80px",
        minWidth: "80px",
        selector: (row) => (
          <div
            onClick={() => {
              if (row.downloadUrl) {
                downloadDownloadedFiles(row.downloadUrl);
                callingTrackingEvents(trackingEventDictionary.requestCentreDownloadsActionDownloadExcel);
              }
            }}
            className="cursor-pointer">
            {row.downloadUrl ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" /> : ""}
          </div>
        ),
        grow: 1,
      },
    ];
    if (GLOBALPLAN) {
      Columns = Columns?.filter((item) => item.id !== "dataSource");
    }
    setColumn(Columns);
  };

  const statusHandling = (row) => {
    if (row.status === "in progress") {
      return (
        <div>
          <p className="m-0 request_status ">{row.status}</p>
          <p className="m-0">Requested records will be delivered shortly</p>
        </div>
      );
    }
    if (row.status === "not delivered") {
      return (
        <div>
          <p className="m-0 request_status request_status_nd">
            {row.status} <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687256871/intel/icons/warning_s7u20r.svg" />
          </p>
          <p>Requested records could not be delivered</p>
        </div>
      );
    }
    if (row.status === "delivered") {
      return (
        <div>
          <p className="m-0 request_status request_status_delivered">
            {row.status} <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687256871/intel/icons/check_circle_bhtwig.svg" />
          </p>
          <p>Requested records delivered on {`${MONTH_ENUM[new Date(row.responseDate).getMonth()]} ${new Date(row.responseDate).getDate()}, ${new Date(row.responseDate).getFullYear()}`}</p>
        </div>
      );
    }
  };

  const filterByStatusHandler = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let descriptionClone = JSON.parse(JSON.stringify(description));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let descriptionValue = "";
    let statusValue = "";
    let datasourceValue = "";
    if (statusClone[index].isChecked) {
      statusClone[index].isChecked = false;
      setStatusCount(statusCount - 1);
    } else {
      statusClone[index].isChecked = true;
      setStatusCount(statusCount + 1);
    }
    setAlertStatus(statusClone);

    descriptionClone.map((item) => {
      if (item.isChecked) {
        descriptionValue += item.type + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("status", statusValue.toLowerCase(), descriptionValue.toLowerCase(), datasourceValue.toUpperCase());
    }, 200);
  };

  const filterByDescriptionHandler = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let descriptionClone = JSON.parse(JSON.stringify(description));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let descriptionValue = "";
    let statusValue = "";
    let datasourceValue = "";
    if (descriptionClone[index].isChecked) {
      descriptionClone[index].isChecked = false;
      setDescriptionCount(descriptionCount - 1);
    } else {
      descriptionClone[index].isChecked = true;
      setDescriptionCount(descriptionCount + 1);
    }
    setDescription(descriptionClone);
    descriptionClone.map((item) => {
      if (item.isChecked) {
        descriptionValue += item.type + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("description", statusValue.toLowerCase(), descriptionValue.toLowerCase(), datasourceValue.toUpperCase());
    }, 200);
  };

  const filterByDataSource = (index) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let descriptionClone = JSON.parse(JSON.stringify(description));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let descriptionValue = "";
    let statusValue = "";
    let datasourceValue = "";

    if (dataSourceClone[index].isChecked) {
      dataSourceClone[index].isChecked = false;
      setDataSourceCount(dataSourceCount - 1);
    } else {
      dataSourceClone[index].isChecked = true;
      setDataSourceCount(dataSourceCount + 1);
    }
    setAlertDataSource(dataSourceClone);

    descriptionClone.map((item) => {
      if (item.isChecked) {
        descriptionValue += item.type + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("datasource", statusValue.toLowerCase(), descriptionValue.toLowerCase(), datasourceValue.toUpperCase());
    }, 200);
  };

  const clearFilterHandler = (type) => {
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let descriptionClone = JSON.parse(JSON.stringify(description));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let descriptionValue = "";
    let statusValue = "";
    let datasourceValue = "";

    if (type === "status") {
      statusClone = statusClone.map((item) => ({ ...item, isChecked: false }));
      setAlertStatus(statusClone);
      setStatusCount(0);
    } else if (type === "description") {
      descriptionClone = descriptionClone.map((item) => ({ ...item, isChecked: false }));
      setDescription(descriptionClone);
      setDescriptionCount(0);
    } else {
      dataSourceClone = dataSourceClone.map((item) => ({ ...item, isChecked: false }));
      setAlertDataSource(dataSourceClone);
      setDataSourceCount(0);
    }

    descriptionClone.map((item) => {
      if (item.isChecked) {
        descriptionValue += item.type + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler(type, statusValue.toLowerCase(), descriptionValue.toLowerCase(), datasourceValue.toUpperCase());
    }, 200);
  };

  const applyFilterHandler = (type, stat, freq, datasource, sortDirection) => {
    setDataList([]);
    setLoader(true);
    setCurrentpage(1);
    Axios.get(apiEndpoint.notification_center + `?source=${REQUEST_SOURCE[2]}&is_notification=false&status=${stat}&request_type=${freq}&data_source=${datasource}&order=${sortDirection ? sortDirection : sortOrderValue}`)
      .then(({ data: { data } }) => {
        setTimeout(() => {
          setDataList(data.data.map((item, index) => ({ ...item, s_no: index })));
          setLoader(false);
        }, 100);
      })
      .catch((err) => {
        captureException(err);
        setLoader(false);
      });
  };

  const clearFilter = () => {
    let descriptionValue = "";
    let statusValue = "";
    let datasourceValue = "";
    setDescriptionCount(0);
    setStatusCount(0);
    setDataSourceCount(0);
    setAlertDataSource(REQUEST_DATASOURCE);
    setDescription(REQUEST_DOWLOAD_DESCRIPTION);
    let statusClone = JSON.parse(JSON.stringify(REQUEST_STATUS));
    statusClone.splice(1, 1);
    setAlertStatus(statusClone);
    setTimeout(() => {
      applyFilterHandler("type", statusValue.toLowerCase(), descriptionValue.toLowerCase(), datasourceValue.toUpperCase());
    }, 200);
  };

  useEffect(() => {
    let pagination = document.querySelectorAll(".rdt_Pagination");
    if (!!pagination && !!pagination.length && !!dataList) {
      if (dataList.length === 1) {
        pagination[0].style.marginTop = "-147px";
      } else if (dataList.length === 2) {
        pagination[0].style.marginTop = "-75px";
      } else if (dataList.length > 2) {
        pagination[0].style.marginTop = "0px";
      }
    }
  }, [dataList, statusCount, dataSourceCount, descriptionCount]);

  const handleSortingClone = (column, sortDirection) => {
    setLoader(true);
    setSortOrderValue(sortDirection);
    setCurrentpage(1);
    setPerPage(10);
    setColumnHandler();
    let statusClone = JSON.parse(JSON.stringify(alertStatus));
    let descriptionClone = JSON.parse(JSON.stringify(description));
    let dataSourceClone = JSON.parse(JSON.stringify(alertDataSource));
    let descriptionValue = "";
    let statusValue = "";
    let datasourceValue = "";

    descriptionClone.map((item) => {
      if (item.isChecked) {
        descriptionValue += item.type + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    dataSourceClone.map((item) => {
      if (item.isChecked) {
        datasourceValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("status", statusValue.toLowerCase(), descriptionValue.toLowerCase(), datasourceValue.toUpperCase(), sortDirection);
    }, 200);
  };
  return (
    <div>
      <div className={`request_center_container ${loader ? "tw-flex tw-justify-center tw-items-center" : ""}`}>
        {loader ? (
          <img src={LoaderImg} alt="description of gif" />
        ) : !propsDataList.length ? (
          <div className="no-data-found">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684997941/intel/icons/emptystate_norequest_b1wzx6.svg" />
            <p>You have not raised any requests yet!</p>
            <p>
              This <strong>Request Centre</strong> will show information on all your raised requests in detail which you can view as per your customised preferences
            </p>
          </div>
        ) : (
          <div>
            <p className="request_center_heading">Access all the details of your download requests here</p>
            <div className="tw-border tw-border-gray-200 tw-rounded-2xl tw-overflow-hidden">
              {!!column && !!column.length ? (
                <ReactTableTrademo
                  columns={column}
                  data={dataList}
                  paginationTotalRows={dataList.length}
                  onSelectedRowsChange={() => {
                    return;
                  }}
                  onSort={handleSortingClone}
                  defaultSortField={"requestDate"}
                  defaultSortAsc={sortOrderValue === "desc" ? false : true}
                  paginationPerPage={perPage}
                  paginationDefaultPage={currentpage}
                  selectedData={[]}
                  sortOrderValue={sortOrderValue}
                  isFilterTrue={dataSourceCount || statusCount || descriptionCount}
                  shipmentDefaultSortValue={sortingColumn}
                  onChangeRowsPerPage={(data) => {
                    setPerPage(data);
                  }}
                  onTableObjectChange={(data) => {
                    setPerPage(data.perPage);
                    setCurrentpage(data.currentPage + 1);
                  }}
                  onChangePage={(page, perPage) => {
                    setCurrentpage(page);
                    setPerPage(perPage);
                  }}
                  noDataComponent=""
                  hideSelection={true}
                  clearFilter={clearFilter}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
